module.exports = __webpack_public_path__ + "first-500_hologram.jpg?896ce860218c1491cc3e0d63e9def1c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500_hologram.jpg
// module id = 555
// module chunks = 0